module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "ulmModThree"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4683.62719,369.194117 C4683.60338,372.420921 4681.51639,373.340961 4679.25362,377.148574 C4676.61353,381.591117 4676.92569,389.551204 4674,396.28246 C4674.84613,397.828629 4679.89066,394.911894 4680.91682,392.207372 C4681.94298,389.502849 4682.721,387.305168 4683.07721,386.620962 C4683.43341,385.936756 4684.32086,385.98374 4684.59238,386.629771 C4684.86391,387.275803 4685.56042,410.766094 4686.118,411.917204 C4686.67558,413.068315 4689.76064,413.10923 4690.29234,411.917204 C4690.82404,410.725178 4690.75184,392.139441 4691.01224,391.641996 C4691.27264,391.144552 4691.95077,391.383975 4692.23705,391.641996 C4692.52333,391.900017 4692.02955,411.753934 4692.49019,412.492759 C4692.95082,413.231585 4696.13691,413.103553 4696.48154,412.492759 C4696.82617,411.881966 4696.94445,392.091282 4697.29089,391.641996 C4697.63733,391.192711 4698.3393,391.243023 4698.62649,391.641996 C4698.91368,392.04097 4698.12998,411.098506 4698.62649,411.917204 C4699.123,412.735902 4702.21215,412.748823 4702.49638,411.917204 C4702.78062,411.085586 4703.4113,391.920377 4703.71052,391.641996 C4704.00974,391.363616 4704.41226,391.389653 4704.69741,391.641996 C4704.98255,391.89434 4705.28427,406.208635 4705.77715,406.986614 C4706.27002,407.764592 4708.60794,407.948418 4708.95257,406.986614 C4709.2972,406.02481 4707.64928,371.130599 4707.69517,369.194117 C4707.84808,362.740661 4703.80439,356 4695.69144,356 C4687.57849,356 4683.67831,362.264822 4683.62719,369.194117 Z",
      "id": "ulm_right_hand",
      "fill": "#94B96B",
      "transform": "translate(4691.500000, 384.500000) rotate(6.000000) translate(-4691.500000, -384.500000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "ulm_right_arm_bottom",
      "fill": "#94B96B",
      "transform": "translate(4700.000000, 345.000000) rotate(6.000000) translate(-4700.000000, -345.000000) ",
      "x": "4688",
      "y": "309",
      "width": "24",
      "height": "72",
      "rx": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "ulm_right_arm_top",
      "fill": "#94B96B",
      "transform": "translate(4705.000000, 290.000000) rotate(6.000000) translate(-4705.000000, -290.000000) ",
      "x": "4693",
      "y": "246",
      "width": "24",
      "height": "88",
      "rx": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4707,246 L4707,246 L4707,246 C4715.83656,246 4723,253.163444 4723,262 L4723,302 L4691,302 L4691,262 L4691,262 C4691,253.163444 4698.16344,246 4707,246 Z",
      "id": "ulm_right_shoulder",
      "fill": "#CDF1A5",
      "transform": "translate(4707.000000, 274.000000) rotate(6.000000) translate(-4707.000000, -274.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4699.31132,516 C4694.67523,518.167183 4681.51784,523.15335 4678.35963,524.446413 C4675.20143,525.739477 4671.22185,531.55 4673.86136,536 C4676.50118,536 4723.68241,536 4727.65787,536 C4729.44738,535.750126 4729.44738,529.08346 4727.65787,516 C4711.94664,516 4702.49779,516 4699.31132,516 Z",
      "id": "ulm_right_shoe",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4713,405 L4713,405 L4713,405 C4724.04569,405 4733,413.954305 4733,425 L4733,516 L4693,516 L4693,425 L4693,425 C4693,413.954305 4701.95431,405 4713,405 Z",
      "id": "ulm_right_leg_bottom",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "ulm_right_leg_top",
      "fill": "#80A259",
      "x": "4693",
      "y": "341",
      "width": "40",
      "height": "104",
      "rx": "20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4747.31132,516 C4742.67523,518.167183 4729.51784,523.15335 4726.35963,524.446413 C4723.20143,525.739477 4719.22185,531.55 4721.86136,536 C4724.50118,536 4771.68241,536 4775.65787,536 C4777.44738,535.750126 4777.44738,529.08346 4775.65787,516 C4759.94664,516 4750.49779,516 4747.31132,516 Z",
      "id": "ulm_left_shoe",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4760,405 L4760,405 L4760,405 C4771.04569,405 4780,413.954305 4780,425 L4780,516 L4740,516 L4740,425 L4740,425 C4740,413.954305 4748.95431,405 4760,405 Z",
      "id": "ulm_left_leg_bottom",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "ulm_left_leg_top",
      "fill": "#80A259",
      "x": "4740",
      "y": "341",
      "width": "40",
      "height": "104",
      "rx": "20"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4693,328 L4780,328 L4780,345 L4780,345 C4780,364.882251 4763.88225,381 4744,381 L4729,381 L4729,381 C4709.11775,381 4693,364.882251 4693,345 L4693,328 Z",
      "id": "ulm_hip",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4723,328 C4724.0707,328 4727.40403,328 4733,328 C4733,352.340343 4733,365.673676 4733,368 C4723.15325,362.857813 4723,354.671875 4723,328 Z",
      "id": "ulm_zipper",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4693,328 L4780,328 L4780,339.95336 C4766.48731,342.194615 4751.4552,343.199289 4734.90367,342.967381 C4718.35214,342.735474 4704.38425,341.7308 4693,339.95336 L4693,328 Z",
      "id": "ulm_belt",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4722.21512,329.005483 L4734.20414,329.633076 C4736.33193,329.74446 4738,331.500215 4738,333.628462 L4738,339.999131 C4738,342.20875 4736.20668,344 4733.99451,344 C4733.9246,344 4733.8547,343.998172 4733.78488,343.994517 L4721.79586,343.366924 C4719.66807,343.25554 4718,341.499785 4718,339.371538 L4718,333.000869 C4718,330.79125 4719.79332,329 4722.00549,329 C4722.0754,329 4722.1453,329.001828 4722.21512,329.005483 Z",
      "id": "ulm_buckle",
      "fill": "#A4CA7A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4738,233.000123 C4751.80383,232.970741 4754.49932,238.233478 4754.13728,239.762568 C4784.98703,241.407049 4780.70815,278.712251 4782.2214,318.074286 C4783.3267,319.089192 4784.83447,320.345079 4784.98703,323.016453 C4785.1396,325.687828 4783.92451,327.145153 4782.46766,328.215959 C4771.32762,335.023693 4707.4319,334.150752 4693.68193,328.215959 C4692.44531,328.033331 4691.3405,325.673107 4691.03225,323.016453 C4690.724,320.3598 4692.7027,318.074286 4693.68193,317.036077 C4695.78848,283.597379 4691.4557,240.162009 4722.39021,239.762568 C4721.81094,236.565818 4724.19617,233.029505 4738,233.000123 Z",
      "id": "ulm_shirt",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4737.81909,233.000164 C4751.6586,232.970648 4754.07877,236.934428 4753.99808,239.793333 C4753.84726,245.137042 4749.48945,250.872598 4740.92466,257 L4732.78181,247.808896 C4728.16461,251.128003 4725.20268,253.271777 4723.896,254.240217 C4721.69835,252.834254 4720.97491,244.441949 4721.00066,239.793333 C4721.02641,235.144716 4723.97958,233.029679 4737.81909,233.000164 Z",
      "id": "ulm_shirt",
      "fill": "#AFD485"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4727.35294,230.447124 C4727.48311,232.569233 4727.16002,237.691886 4726,239.708823 C4726.64335,240.451867 4728.79908,242.882259 4732.46718,247 C4742.62047,243.27529 4748.13141,240.844897 4749,239.708823 C4747.56758,237.720923 4747.48671,233.080047 4747.64706,230.447124 C4745.68536,227.128979 4730.0922,227.240077 4727.35294,230.447124 Z",
      "id": "ulm_neck",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4757.62719,372.194117 C4757.60338,375.420921 4755.51639,376.340961 4753.25362,380.148574 C4750.61353,384.591117 4750.92569,392.551204 4748,399.28246 C4748.84613,400.828629 4753.89066,397.911894 4754.91682,395.207372 C4755.94298,392.502849 4756.721,390.305168 4757.07721,389.620962 C4757.43341,388.936756 4758.32086,388.98374 4758.59238,389.629771 C4758.86391,390.275803 4759.56042,413.766094 4760.118,414.917204 C4760.67558,416.068315 4763.76064,416.10923 4764.29234,414.917204 C4764.82404,413.725178 4764.75184,395.139441 4765.01224,394.641996 C4765.27264,394.144552 4765.95077,394.383975 4766.23705,394.641996 C4766.52333,394.900017 4766.02955,414.753934 4766.49019,415.492759 C4766.95082,416.231585 4770.13691,416.103553 4770.48154,415.492759 C4770.82617,414.881966 4770.94445,395.091282 4771.29089,394.641996 C4771.63733,394.192711 4772.3393,394.243023 4772.62649,394.641996 C4772.91368,395.04097 4772.12998,414.098506 4772.62649,414.917204 C4773.123,415.735902 4776.21215,415.748823 4776.49638,414.917204 C4776.78062,414.085586 4777.4113,394.920377 4777.71052,394.641996 C4778.00974,394.363616 4778.41226,394.389653 4778.69741,394.641996 C4778.98255,394.89434 4779.28427,409.208635 4779.77715,409.986614 C4780.27002,410.764592 4782.60794,410.948418 4782.95257,409.986614 C4783.2972,409.02481 4781.64928,374.130599 4781.69517,372.194117 C4781.84808,365.740661 4777.80439,359 4769.69144,359 C4761.57849,359 4757.67831,365.264822 4757.62719,372.194117 Z",
      "id": "ulm_left_hand",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "ulm_left_arm_bottom",
      "fill": "#94B96B",
      "x": "4758",
      "y": "311",
      "width": "24",
      "height": "72",
      "rx": "12"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "ulm_left_arm_top",
      "fill": "#94B96B",
      "x": "4758",
      "y": "248",
      "width": "24",
      "height": "88",
      "rx": "12"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4770,248 L4770,248 L4770,248 C4778.83656,248 4786,255.163444 4786,264 L4786,304 L4754,304 L4754,264 L4754,264 C4754,255.163444 4761.16344,248 4770,248 Z",
      "id": "ulm_left_shoulder",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4765.49102,197.353936 C4767.1898,196.360306 4769.82065,194.000342 4772.58571,196.256241 C4775.35078,198.51214 4775.56052,203.156575 4774.1254,207.774331 C4772.57072,212.776807 4769.73733,214.725816 4765.49102,214.586025 C4763.69095,220.948835 4758.11125,228.158156 4753.28694,230.610708 C4748.46264,233.063259 4736.72003,233.024012 4733.11913,232.992677 C4724.04437,232.91371 4718.66688,230.557671 4714.20713,224.328665 C4709.12712,217.233332 4708,204.899656 4708,196.256241 C4708,185.337023 4709.78906,177.459171 4713.35475,172.114168 C4718.0466,165.081056 4718.68008,171.105262 4733.11913,170.817914 C4747.55818,170.530566 4754.31939,163.858663 4759.78828,172.114168 C4763.28667,177.395124 4766.99245,186.588994 4765.49102,197.353936 Z",
      "id": "ulm_face",
      "fill": "#94B96B",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4709.01621,186.296678 C4708.66839,168.69264 4713.75378,156.86569 4740.38283,157.001152 C4769.41323,157.148829 4776.61319,166.778699 4773.22962,196.332074 C4770.00374,193.660996 4766.59437,197.137852 4765.99038,197.278692 C4764.29958,199.984541 4762.67661,210.444744 4765.99038,214.451029 C4765.99038,224.449701 4759.5757,232.693752 4749.78047,234.015109 C4742.63676,234.97878 4727.42108,236.007317 4720.5828,233.026298 C4712.52395,229.513199 4710.11931,217.798633 4711.06987,217.299867 C4716.4993,214.451029 4741.56539,213.998633 4756.30648,217.299867 C4759.90891,218.106622 4760.7919,205.751443 4760.89764,203.915172 C4761.70215,189.943759 4762.41084,171.776563 4754.16957,168.645758 C4749.39474,166.831831 4749.2186,170.762462 4733.10412,170.762462 C4724.36225,170.762462 4720.846,168.322544 4717.37157,168.645758 C4714.02864,168.956739 4710.02604,179.099087 4709.01621,186.296678 Z",
      "id": "ulm_hair",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4765,204.42225 C4765.51919,199.351645 4769.1148,195.789513 4771.81184,197.38486 C4774.50889,198.980207 4772.66277,212.446246 4765.77755,210.872311 C4765.96625,210.072352 4767.25524,208.07248 4767.33266,206.034765 C4767.41008,203.99705 4766.11563,203.96643 4765,204.42225 Z",
      "id": "ulm_ear",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "ulm_mouth_bottom"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4727.32575,225 C4728.47905,225 4738.49181,225 4739.78027,225 C4741.06873,225 4736.44625,223 4732.29344,223 C4728.14062,223 4726.17245,225 4727.32575,225 Z",
      "fill": "#80A259",
      "transform": "translate(4733.500000, 224.000000) scale(1, -1) translate(-4733.500000, -224.000000) "
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4725.40093,223 C4726.82037,223 4739.14376,223 4740.72956,223 C4742.31536,223 4736.62615,220 4731.515,220 C4726.40384,220 4723.98148,223 4725.40093,223 Z",
      "id": "ulm_mouth_top",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4730.19379,197.075428 C4730.55153,194.708987 4734.91645,193.934368 4735.21212,197.075428 C4735.50779,200.216488 4736.82516,209.885327 4735.21458,211.795518 C4733.60401,213.705709 4728.86951,213.065705 4728.13682,211.795518 C4727.40412,210.52533 4729.83605,199.441869 4730.19379,197.075428 Z",
      "id": "ulm_nose",
      "fill": "#80A259"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "ulm_glasses_3",
      "stroke": "#6D8C4A",
      "stroke-width": "2",
      "fill": "#CDF1A5",
      "x": "4738",
      "y": "194",
      "width": "20",
      "height": "14",
      "rx": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4727.38462,201 L4737,201",
      "id": "ulm_glasses_2",
      "stroke": "#6D8C4A",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "ulm_glasses_1",
      "stroke": "#6D8C4A",
      "stroke-width": "2",
      "fill": "#CDF1A5",
      "x": "4707",
      "y": "194",
      "width": "20",
      "height": "14",
      "rx": "5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4739.03294,190.621746 C4739.5433,187.226369 4755.65524,187.17293 4755.97857,190.206047 C4756.3019,193.239164 4752.92752,191.792949 4748.48645,192.373277 C4744.04538,192.953606 4738.52258,194.017123 4739.03294,190.621746 Z",
      "id": "ulm_left_brow",
      "fill": "#6D8C4A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M4724.96706,190.621746 C4724.4567,187.226369 4708.34476,187.17293 4708.02143,190.206047 C4707.6981,193.239164 4711.07248,191.792949 4715.51355,192.373277 C4719.95462,192.953606 4725.47742,194.017123 4724.96706,190.621746 Z",
      "id": "ulm_right_brow",
      "fill": "#6D8C4A"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ec24dfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/background/ulmModThree.vue
// module id = 749
// module chunks = 1